import { useEffect, useState } from 'react';
import { convertMJD } from '../utils/timeUtils';

function Clock(props) {
  const [date, setDate] = useState(new Date());
  const { timezone } = props;

  useEffect(() => {
    const dateInterval = setInterval(() => {
      setDate(new Date())
    }, 1000)
    return () => clearInterval(dateInterval);
  }, []);

  let value;

  if (timezone === 'MJD') {
    value = `MJD ${convertMJD(date)}`;
  } else {
    const options = { timeZone: timezone, timeZoneName: 'short', hour: '2-digit', minute: '2-digit' }
    value = date.toLocaleTimeString('en-US', options);
  }
  return (
    <div>{value}</div>
  );
}

export default Clock;
